import QuickView from '../components/quickView';

export default class Plp {
  constructor() {
    this.featuredCarousel = document.querySelector('#plp-hero .featured .main-carousel');

    this._init();
  }

  _init() {
    const quickView = new QuickView('.modal');

    if (this.featuredCarousel) {
      const carousel = new Flickity(this.featuredCarousel, {
        freeScroll: true,
        contain: true,
        pageDots: false,
        groupCells: true,
        on: {
          ready: () => {
            setTimeout(() => {
              const pagers = this.featuredCarousel.querySelectorAll('.flickity-prev-next-button');

              pagers.forEach((pager) => {
                pager.innerHTML = `
                  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 17L9 9L0.999999 1" stroke="#111E90" stroke-width="2"/>
                  </svg>                            
                `;
              });
            }, 0);
          }
        }
      });
    }
  }
}
